const STORAGE_KEY = 'snail_sound_tag_preferences_v1'
const CHANGE_EVENT = 'snail_sound_tag_preferences_changed'

const DEFAULT_PREFERENCES = {
  defaultEditorMode: 'guided'
}

/**
 * 将本地存储中的任意值收口成受支持的标签编辑偏好。
 *
 * @param {Object} value 原始偏好
 * @returns {{defaultEditorMode: string}}
 */
function normalizePreferences(value = {}) {
  return {
    defaultEditorMode: value.defaultEditorMode === 'quick' ? 'quick' : 'guided'
  }
}

/**
 * 读取当前电脑上的标签编辑偏好。
 *
 * 本地内容损坏时回退引导模式，不把个人偏好写入数据库，也不会影响其他
 * 管理员账号或其他电脑。
 *
 * @returns {{defaultEditorMode: string}}
 */
export function getSoundTagPreferences() {
  try {
    const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}')
    return normalizePreferences(value)
  } catch (error) {
    return { ...DEFAULT_PREFERENCES }
  }
}

/**
 * 保存本地标签编辑偏好并通知当前页面中的复用组件。
 *
 * @param {Object} value 新偏好
 * @returns {{defaultEditorMode: string}}
 */
export function saveSoundTagPreferences(value) {
  const preferences = normalizePreferences(value)
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences))
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: preferences }))
  return preferences
}

export const SOUND_TAG_PREFERENCES_CHANGE_EVENT = CHANGE_EVENT
